import { render } from "./BaseMessageItem.vue?vue&type=template&id=1cbd7fe8&scoped=true"
import script from "./BaseMessageItem.vue?vue&type=script&lang=js"
export * from "./BaseMessageItem.vue?vue&type=script&lang=js"

import "./BaseMessageItem.vue?vue&type=style&index=0&id=1cbd7fe8&lang=scss&scoped=true"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbd7fe8"]])

export default __exports__